import { Card, Typography } from "antd";
import styles from "../../../deliveryServices/DeliveryServices.module.css";

const { Text } = Typography;

function FailedCard({ date }) {
  return (
    <Card className={styles.dsCardStyleError}>
      <Text className={styles.dsCardTitleError}>Onboarding Request Failed</Text>
      <p className={styles.dsCardDateError}>{date}</p>
      <p className={styles.dsFormLabels}>
        Check your email, inventory or store hours. Click <b>Retry</b> to try again. If you need assistance, reach out to Customer Service at <b>(818) 235-1327</b>.
      </p>
    </Card>
  );
}

export default FailedCard;
